import React from "react";
import { Col, Row, Icon } from "antd";
import moment from "moment";
import LoadingIndicator from "../shared/LoadingIndicator/LoadingIndicator";
import BacklinksOverviewBox from "./BacklinksOverviewBox";
import TableColumnWithTooltip from "../shared/TableColumnWithTooltip/TableColumnWithTooltip";

const getLastOverview = (overview, resourceType) => {
  if (overview && resourceType in overview && overview[resourceType].length) {
    let result = overview[resourceType][overview[resourceType].length - 1]["value"];
    if (resourceType === "domain_score") {
      result = `${result}/100`;
    }
    return result;
  }
  return 0;
};

const getTrend = (overview, resourceType) => {
  if (overview && resourceType in overview && overview[resourceType].length) {
    let count = overview[resourceType].length;

    if (count > 1) {
      let first = overview[resourceType][0]["value"];
      let last = overview[resourceType][count - 1]["value"];

      if (first < last) {
        return <Icon type="arrow-up" style={{ color: "#3f8600" }} />;
      } else if (first > last) {
        return <Icon type="arrow-down" style={{ color: "#cf1322" }} />;
      }
    }
  }

  return <Icon type="swap" />;
};

const tooltipLabels = {
  total_backlinks: "Total Backlinks",
  referring_domains: "Referring Domains",
  domain_score: "Domain Score",
  follow_links: "Follow Links",
  nofollow_links: "Nofollow links"
};

const getChartData = (overview, resourceType) => {
  let overviewData =
    overview && overview[resourceType]
      ? overview[resourceType].map(item => ({ ...item, type: tooltipLabels[resourceType] }))
      : [];

  return getVisibleOverviewData(overviewData);
};

export const getVisibleOverviewData = overviewData => {
  const weeklyPoints = [];
  const pointsInReverse = [...overviewData];
  pointsInReverse.reverse();
  weeklyPoints.unshift(pointsInReverse[0]);
  let nextDesiredMoment = pointMoment(pointsInReverse[0]).subtract(1, "weeks");
  pointsInReverse.forEach(element => {
    const elCreatedAt = pointMoment(element);
    // data from server comes every 24h +/- a couple of seconds/minutes
    if (!elCreatedAt.isAfter(nextDesiredMoment, "day")) {
      weeklyPoints.unshift(element);
      nextDesiredMoment = pointMoment(element).subtract(1, "weeks");
    }
  });
  return weeklyPoints.slice(-4);
};

const pointMoment = point => moment(point["c_at"]);

const BacklinksOverview = ({ isLoading, overview, settings, showChart }) => {
  return (
    <React.Fragment>
      {!isLoading ? (
        overview && overview["total_backlinks"] && overview["total_backlinks"].length ? (
          <Row gutter={20} className="backlinks-overview-wrapper">
            {settings.map(item => (
              <Col className="overview-box" key={item.key}>
                <BacklinksOverviewBox
                  title={<TableColumnWithTooltip title={item.title} tooltip={item.tooltip} noFill />}
                  value={getLastOverview(overview, item.key)}
                  trend={getTrend(overview, item.key)}
                  chartData={getChartData(overview, item.key)}
                  showChart={showChart}
                />
              </Col>
            ))}
          </Row>
        ) : null
      ) : (
        <LoadingIndicator />
      )}
    </React.Fragment>
  );
};

export default BacklinksOverview;
